<template>
  <div :class="ns.b()">
    <app-title-bar
      v-if="showTitleBar"
      :dark="dark"
      :maximized="maximized"
      :show-window-controls="showWindowControls"
      :platform="platform"
      @minimize="emit('minimize')"
      @toggle-maximize="emit('toggle-maximize')"
      @close="emit('close')"
    >
      <template #brand>
        <slot name="brand" />
      </template>
      <template #nav>
        <slot name="header-nav" />
      </template>
      <template #actions>
        <slot name="header-actions" />
      </template>
    </app-title-bar>
    <div :class="ns.e('body')">
      <slot name="rail" />
      <div :class="ns.e('content')">
        <slot name="tags" />
        <div :class="ns.e('stage')">
          <slot name="aside" />
          <z-main :class="ns.e('main')">
            <slot />
          </z-main>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useNamespace } from '@zoryn/hooks'
import { ZMain } from '@zoryn/components/container'
import AppTitleBar from './app-title-bar.vue'
import type { AppTitleBarPlatform } from './types'

defineOptions({
  name: 'ZAppShell',
})

withDefaults(
  defineProps<{
    dark?: boolean
    maximized?: boolean
    showWindowControls?: boolean
    platform?: AppTitleBarPlatform
    showTitleBar?: boolean
  }>(),
  {
    dark: false,
    maximized: false,
    showWindowControls: false,
    platform: 'web',
    showTitleBar: true,
  }
)

const emit = defineEmits<{
  minimize: []
  'toggle-maximize': []
  close: []
}>()

const ns = useNamespace('app-shell')
</script>
